<script setup lang="ts">
const value = defineModel<string>({ required: true });

const { type = "text", isError = false } = defineProps<{
    type?: "text" | "email" | "tel";
    isError?: boolean;
}>();
</script>

<!-- Остальные атрибуты (placeholder, autocomplete, id...) попадают на сам input -->
<template>
    <input v-model="value" :type="type" class="input" :class="{ input_error: isError }" />
</template>

<style scoped>
.input {
    width: 100%;
    height: 40px;
    padding: 10px 16px;
    border: 1px solid var(--custom-color-gray);
    border-radius: 6px;
    background-color: #fff;
    color: inherit;
    font: inherit;
    font-size: var(--custom-font-size);
    transition:
        border-color 150ms ease,
        box-shadow 150ms ease;

    &::placeholder {
        color: var(--custom-color-gray);
    }

    &:hover {
        border-color: var(--custom-color-main-hover, var(--custom-color-main));
    }

    &:focus {
        border-color: var(--custom-color-main);
        outline: none;
        box-shadow: 0 1px 4px 0 color-mix(in srgb, var(--custom-color-main), transparent 60%);
    }

    &:disabled {
        border-color: #d9dde1;
        background-color: #f7f9fc;
        color: #a9b3bd;
        cursor: not-allowed;
    }
}

.input_error,
.input_error:hover {
    border-color: var(--color-error);
}
</style>
